import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

import Api from "@/services/api"
    import { Category, Product } from "@/services/types"
    import { ElCol, ElMessage, ElMessageBox, ElRow, FormInstance, FormRules } from "element-plus"
    import { onBeforeMount, reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateProduct',
  setup(__props) {

    const store = useStore()
    const router = useRouter()
    const product = reactive<Product>({
        name: '',
        description: '',
        price: 0,
        categories: [],
        images: [],
        quantity: 1,
        promoction: 0,
    })

    const properties = ref<Record<string, string>>({
        Marca: '',
        'Modelo / Referência': '',
        Cor: '',
        'Tamanho / Dimensões': '',
        Peso: '',
        'Material / Composição': '',
        'Estado do produto': ''
    })

    const rules = reactive<FormRules<Product>>({
        name: [{required: true, message: 'Insira o nome do produto', min: 1}],
        categories: [
            {required: true, message: 'Selecione as categorias'}
        ],
        description: [{required: true, message: 'A descrição é obrigatória'}],
        images: [
            {required: true, message: 'Selecione as imagens', trigger: 'blur'}
        ],
        price: [
            {required: true, message: 'Indique o preco do produto'}
        ],
        quantity: [
            {required: true, message: "Informar quantidade disponivel"},
            // {min: 0, message: 'Maior que zero'}
        ]
    })

    const images = ref()
    const uris = ref<string>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)
    
    const categories = reactive<Array<Category>>([])

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('admin/categories')
        console.log(res)
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message)
        } else {
            const data = res.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }
        loading.value = false
    })

    const selectImages = () => {
        console.log(images.value?.input.files)
        product.images?.splice(0)
        for (let i = 0; i < images.value?.input.files.length; i++) {
            product.images?.push(images.value?.input.files[i])
        }

        console.log(product.images)
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = new FormData()
                data.append('name', product.name)
                data.append('price', `${product.price}`)
                data.append('promoction', `${product.promoction}`)
                data.append('quantity', `${product.quantity}`)
                data.append('description', product.description)

                // categorias
                product.categories?.forEach((c, i) => {
                    data.append(`categories[${i}]`, c.toString())
                })

                // imagens
                product.images?.forEach((img: any, i) => {
                    data.append(`images[${i}]`, img)
                })

                // propriedades
                Object.keys(properties.value).forEach(prop => {
                    if (properties.value[prop] && properties.value[prop].trim().length > 0) {
                        data.append(`properties[${prop}]`, properties.value[prop])
                    }
                })

                const res = await Api.post('admin/products', product, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Produtos cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                    // router.push('/products')
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    loading: loading.value,
    animated: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        disabled: saving.value,
        rules: rules,
        model: product,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "name",
            label: "Nome do produto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "name",
                modelValue: product.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((product.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ElCol), {
                xs: 24,
                md: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "price",
                    label: "Preço"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        step: 0.0001,
                        min: 0.001,
                        name: "price",
                        modelValue: product.price,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((product.price) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(ElCol), {
                xs: 24,
                md: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "quantity",
                    label: "Quantidade em estoque"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        step: 1,
                        min: 0,
                        name: "quantity",
                        modelValue: product.quantity,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((product.quantity) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "images",
            label: "Selecione as imagens do produto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                multiple: "",
                modelValue: uris.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((uris).value = $event)),
                type: "file",
                ref_key: "images",
                ref: images,
                name: "images",
                onChange: selectImages
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Selecionar categorias do produto",
            prop: "categories"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: product.categories,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((product.categories) = $event)),
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories, (c) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: c.name,
                      value: c.id,
                      key: c.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(c.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider),
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Epecifique algumas caracteristicas (opcionais)", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(properties.value), (key) => {
            return (_openBlock(), _createBlock(_component_el_form_item, {
              label: key,
              key: key
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  name: "key",
                  modelValue: properties.value[key],
                  "onUpdate:modelValue": ($event: any) => ((properties.value[key]) = $event),
                  placeholder: "Informe se aplicavel"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128)),
          _createVNode(_component_el_divider),
          _createVNode(_component_el_form_item, {
            label: "Descrição",
            prop: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                name: "description",
                modelValue: product.description,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((product.description) = $event)),
                minlength: "1"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            loading: saving.value,
            size: "large",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Cadastrar ", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["disabled", "rules", "model"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})